import React from 'react'
import { NavLink } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import iden from './assets/iden.jpg'
import fnd from './assets/fnd.jpg'
import tds from './assets/tds.jfif'
import gid from './assets/gld.jpg'
import pw from './assets/pw.jfif'
import monty from './assets/monty.png'
import blb from './assets/blb.jpg'
import contmd from './assets/contmd.jpg'
import fasthors from './assets/fasthors.jfif'
import pil from './assets/pil.jpg'
import coinBag from './assets/coinBag.jfif'
import probab from './assets/probab.jfif'
import prisn from './assets/prisn.png'
import plyr from './assets/plyr.jpg'
import CamelBan from './assets/CamelBan.png'
import drs from './assets/drs.jpg'
import rtio from './assets/rtio.png'
import brde from './assets/brde.jpg'
import poisn from './assets/poisn.jfif'
import prts from './assets/prts.png'
import ants from './assets/ants.JPG'
import mxmChoc from './assets/mxmChoc.png'
import cube from './assets/cube.png'
import coins from './assets/coins.jpg'
import chess from './assets/chess.png'
import sal from './assets/sal.jpg'
import hrgless from './assets/hrgless.jpg'
import news from './assets/news.jfif'
import crwhl from './assets/crwhl.jfif'
import plndrm from './assets/plndrm.png'
import mnmCt from './assets/mnmCt.png'
import compitn from './assets/compltn.jfif'
import rs from './assets/rs.jfif'
import police from './assets/police.jpg'
import egg from './assets/egg.jpg'
import match from './assets/match.jfif'
import mxmERun from './assets/mxmERun.jfif'
import ttt from './assets/ttt.jfif'
import coin from './assets/coin.jfif'
import mis from './assets/mis.jfif'
import guess from './assets/guess.jpg'
import placing from './assets/placing.png'
import muddyHead from './assets/muddyHead.jpg'
import gb from './assets/gb.png'
import stc from './assets/ftc.jfif'
const Puzz1 = () => {
    return (
        <div>
            <h1>Puzzel over Logical thinking and Programming languages</h1>
            <div class="cards-list" data-aos="fade-up" data-aos-delay="100">
  
  <div class="card 1">
    <div class="card_image"> <img src={iden}/> </div>
    <div class="card_title title-white">
      <p style={{fontSize:'.7em',color:'green'}}> Measure 45 minutes using two identical wires</p>
      <NavLink to='/category/Puzzels/Puzzel1'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
    <div class="card 2">
    <div class="card_image">
      
      <img src={fnd} />
      </div>
    <div class="card_title title-white">
      <p style={{fontSize:'.7em',color:'green'}}>Find ages of daughters</p>
      <NavLink to='/category/Puzzels/Puzzel2'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
  <div class="card 1">
    <div class="card_image">
      <img src={tds} />
    </div>
    <div class="card_title">
        <p style={{fontSize:'.7em',color:'green'}}>Calculate total distance travelled by bee</p>
        <NavLink to='/category/Puzzels/Puzzel3'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    
    <div class="card 2">
    <div class="card_image">
      <img src={gid} />
      </div>
    <div class="card_title title-black">
      <p style={{fontSize:'.7em',color:'green'}}>Pay an employee using a 7 units gold rod</p>
      <NavLink to='/category/Puzzels/Puzzel4'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
    </div>
   
    </div>
          <div class="cards-list"data-aos="fade-up" data-aos-delay="100">
    
  <div class="card 3">
    <div class="card_image"> <img src={pw}/> </div>
    <div class="card_title title-white">
      <p style={{fontSize:'.7em',color:'green'}}>Finding the poisoned wine</p>
      <NavLink to='/category/Puzzels/Puzzel5'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
    <div class="card 4">
    <div class="card_image">
      <img src={monty} />
      </div>
    <div class="card_title title-white">
      <p style={{fontSize:'.7em',color:'green'}}>Monty Hall problem</p>
      <NavLink to='/category/Puzzels/Puzzel6'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
  <div class="card 3">
    <div class="card_image">
      <img src={blb} />
    </div>
    <div class="card_title">
        <p style={{fontSize:'.7em',color:'green'}}>3 Bulbs and 3 Switches</p>
        <NavLink to='/category/Puzzels/Puzzel7'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    
    <div class="card 4">
    <div class="card_image">
      <img src={contmd} />
      </div>
    <div class="card_title title-black">
      <p style={{fontSize:'.7em',color:'green'}}>Find the Jar with contaminated pills</p>
      <NavLink to='/category/Puzzels/Puzzel8'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
    </div>
   
    </div>
            <div class="cards-list" data-aos="fade-up" data-aos-delay="100">
  
  <div class="card 1">
    <div class="card_image"> <img src={fasthors}/> </div>
    <div class="card_title title-white">
      <p style={{fontSize:'.7em',color:'darkgreen'}}>Find the fastest 3 horses</p>
      <NavLink to='/category/Puzzels/Puzzel9'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
    <div class="card 2">
    <div class="card_image">
      
      <img src={pil}/>
      </div>
    <div class="card_title title-white">
      <p style={{fontSize:'.7em',color:'green'}}>A Man with Medical Condition and 2 Pills</p>
      <NavLink to='/category/Puzzels/Puzzel10'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
  <div class="card 1">
    <div class="card_image">
      <img src={coinBag} />
    </div>
    <div class="card_title">
        <p style={{fontSize:'.7em',color:'green'}}>1000 Coins and 10 Bags</p>
        <NavLink to='/category/Puzzels/Puzzel11'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    
    <div class="card 2">
    <div class="card_image">
      <img src={probab} />
      </div>
    <div class="card_title title-black">
      <p style={{fontSize:'.7em',color:'green'}}>Maximize probability of White Ball</p>
      <NavLink to='/category/Puzzels/Puzzel12'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
    </div>
   
    </div>
          <div class="cards-list"data-aos="fade-up" data-aos-delay="100">
    
  <div class="card 3">
    <div class="card_image"> <img src={prisn} /> </div>
    <div class="card_title title-white">
      <p style={{fontSize:'.7em',color:'green'}}>100 Prisoners with Red/Black Hats</p>
      <NavLink to='/category/Puzzels/Puzzel13'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
    <div class="card 4">
    <div class="card_image">
      <img src={plyr} />
      </div>
    <div class="card_title title-white">
      <p style={{fontSize:'.7em',color:'green'}}>Strategy for a 2 Player Coin Game</p>
      <NavLink to='/category/Puzzels/Puzzel14'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
  <div class="card 3">
    <div class="card_image">
      <img src={CamelBan} />
    </div>
    <div class="card_title">
        <p style={{fontSize:'.7em',color:'green'}}>Camel and Banana Puzzle</p>
        <NavLink to='/category/Puzzels/Puzzel15'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    
    <div class="card 4">
    <div class="card_image">
      <img src={drs} />
      </div>
    <div class="card_title title-black">
      <p style={{fontSize:'.7em',color:'green'}}>100 Doors</p>
      <NavLink to='/category/Puzzels/Puzzel16'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
    </div>
   
    </div>
            <div class="cards-list" data-aos="fade-up" data-aos-delay="100">
  
  <div class="card 1">
    <div class="card_image"> <img src={rtio}/> </div>
    <div class="card_title title-white">
      <p style={{fontSize:'.7em',color:'green'}}>Ratio of Boys and Girls in a Country where people want only boys</p>
      <NavLink to='/category/Puzzels/Puzzel17'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
    <div class="card 2">
    <div class="card_image">
      
      <img src={brde}/>
      </div>
    <div class="card_title title-white">
      <p style={{fontSize:'.7em',color:'green'}}>Torch and Bridge</p>
      <NavLink to='/category/Puzzels/Puzzel18'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
  <div class="card 1">
    <div class="card_image">
      <img src={poisn} />
    </div>
    <div class="card_title">
        <p style={{fontSize:'.7em',color:'green'}}>Poison and Rat</p>
        <NavLink to='/category/Puzzels/Puzzel19'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    
    <div class="card 2">
    <div class="card_image">
      <img src={prts} />
      </div>
    <div class="card_title title-black">
      <p style={{fontSize:'.7em',color:'green'}}>5 Pirates and 100 Gold Coins</p>
      <NavLink to='/category/Puzzels/Puzzel20'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
    </div>
   
    </div>
          <div class="cards-list"data-aos="fade-up" data-aos-delay="100">
    
  <div class="card 3">
    <div class="card_image"> <img src={ants} /> </div>
    <div class="card_title title-white">
      <p style={{fontSize:'.7em',color:'green'}}>3 Ants and Triangle</p>
      <NavLink to='/category/Puzzels/Puzzel21'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
    <div class="card 4">
    <div class="card_image">
      <img src={mxmChoc} />
      </div>
    <div class="card_title title-white">
      <p style={{fontSize:'.7em',color:'green'}}>Maximum Chocolates</p>
      <NavLink to='/category/Puzzels/Puzzel22'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
  <div class="card 3">
    <div class="card_image">
      <img src={cube} />
    </div>
    <div class="card_title">
        <p style={{fontSize:'.7em',color:'green'}}>Days of month using 2 dice</p>
        <NavLink to='/category/Puzzels/Puzzel23'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    
    <div class="card 4">
    <div class="card_image">
      <img src={coins} />
      </div>
    <div class="card_title title-black">
      <p style={{fontSize:'.7em',color:'green'}}>10 Coins Puzzle</p>
      <NavLink to='/category/Puzzels/Puzzel24'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
    </div>
   
    </div>
            <div class="cards-list" data-aos="fade-up" data-aos-delay="100">
  
  <div class="card 1">
    <div class="card_image"> <img src={chess} /> </div>
    <div class="card_title title-white">
      <p style={{fontSize:'.7em',color:'green'}}>Chessboard and dominos</p>
      <NavLink to='/category/Puzzels/Puzzel25'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
    <div class="card 2">
    <div class="card_image">
      
      <img src={sal} />
      </div>
    <div class="card_title title-white">
      <p style={{fontSize:'.7em',color:'green'}}>Know Average Salary without Disclosing Individual Salaries</p>
      <NavLink to='/category/Puzzels/Puzzel26'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
  <div class="card 1">
    <div class="card_image">
      <img src={hrgless} />
    </div>
    <div class="card_title">
        <p style={{fontSize:'.7em',color:'green'}}>Hourglasses Puzzle</p>
        <NavLink to='/category/Puzzels/Puzzel27'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    
    <div class="card 2">
    <div class="card_image">
      <img src={news} />
      </div>
    <div class="card_title title-black">
      <p style={{fontSize:'.7em',color:'green'}}>Newspaper Puzzle</p>
      <NavLink to='/category/Puzzels/Puzzel28'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
    </div>
   
    </div>
          <div class="cards-list"data-aos="fade-up" data-aos-delay="100">
    
  <div class="card 3">
    <div class="card_image"> <img src={crwhl} /> </div>
    <div class="card_title title-white">
      <p style={{fontSize:'.7em',color:'green'}}>Car Wheel Puzzle</p>
      <NavLink to='/category/Puzzels/Puzzel29'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
    <div class="card 4">
    <div class="card_image">
      <img src={plndrm} />
      </div>
    <div class="card_title title-white">
      <p style={{fontSize:'.7em',color:'green'}}>Last Palindrome Date Before 10/02/2001</p>
      <NavLink to='/category/Puzzels/Puzzel30'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
  <div class="card 3">
    <div class="card_image">
      <img src={mnmCt} />
    </div>
    <div class="card_title">
        <p style={{fontSize:'.7em',color:'green'}}>Minimum cut Puzzle</p>
        <NavLink to='/category/Puzzels/Puzzel31'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    
    <div class="card 4">
    <div class="card_image">
      <img src={compitn} />
      </div>
    <div class="card_title title-black">
      <p style={{fontSize:'.7em',color:'green'}}>Completion of Task</p>
      <NavLink to='/category/Puzzels/Puzzel32'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
    </div>
   
    </div>
            <div class="cards-list" data-aos="fade-up" data-aos-delay="100">
  
  <div class="card 1">
    <div class="card_image"> <img src={rs}/> </div>
    <div class="card_title title-white">
      <p style={{fontSize:'.7em',color:'green'}}>Rs 500 Note Puzzle</p>
      <NavLink to='/category/Puzzels/Puzzel33'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
    <div class="card 2">
    <div class="card_image">
      
      <img src={police} />
      </div>
    <div class="card_title title-white">
      <p style={{fontSize:'.7em',color:'green'}}>Prisoner and Policeman Puzzle</p>
      <NavLink to='/category/Puzzels/Puzzel34'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
  <div class="card 1">
    <div class="card_image">
      <img src={egg} />
    </div>
    <div class="card_title">
        <p style={{fontSize:'.7em',color:'green'}}>2 Eggs and 100 Floors</p>
        <NavLink to='/category/Puzzels/Puzzel35'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    
    <div class="card 2">
    <div class="card_image">
      <img src={match} />
      </div>
    <div class="card_title title-black">
      <p style={{fontSize:'.7em',color:'green'}}>Matchstick Puzzle</p>
      <NavLink to='/category/Puzzels/Puzzel36'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
    </div>
   
    </div>
          <div class="cards-list"data-aos="fade-up" data-aos-delay="100">
    
  <div class="card 3">
    <div class="card_image"> <img src={mxmERun} /> </div>
    <div class="card_title title-white">
      <p style={{fontSize:'.7em',color:'green'}}>Maximum run in cricket</p>
      <NavLink to='/category/Puzzels/Puzzel37'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
    <div class="card 4">
    <div class="card_image">
      <img src={ttt} />
      </div>
    <div class="card_title title-white">
      <p style={{fontSize:'.7em',color:'green'}}>Tic Tac Toe Puzzle</p>
      <NavLink to='/category/Puzzels/Puzzel38'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
  <div class="card 3">
    <div class="card_image">
      <img src={coin} />
    </div>
    <div class="card_title">
        <p style={{fontSize:'.7em',color:'green'}}>100 coins puzzle</p>
        <NavLink to='/category/Puzzels/Puzzel39'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    
    <div class="card 4">
    <div class="card_image">
      <img src={mis} />
      </div>
    <div class="card_title title-black">
      <p style={{fontSize:'.7em',color:'green'}}>(Find missing Row in Excel</p>
      <NavLink to='/category/Puzzels/Puzzel40'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
    </div>
   
    </div>
            <div class="cards-list" data-aos="fade-up" data-aos-delay="100">
  
  <div class="card 1">
    <div class="card_image"> <img src={guess}/> </div>
    <div class="card_title title-white">
      <p style={{fontSize:'.7em',color:'green'}}>Guess Color of Hat</p>
      <NavLink to='/category/Puzzels/Puzzel41'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
    <div class="card 2">
    <div class="card_image">
      
      <img src={placing} />
      </div>
    <div class="card_title title-white">
      <p style={{fontSize:'.7em',color:'green'}}>Placing the numbers</p>
      <NavLink to='/category/Puzzels/Puzzel42'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
  <div class="card 1">
    <div class="card_image">
      <img src={muddyHead} />
    </div>
    <div class="card_title">
        <p style={{fontSize:'.7em',color:'green'}}>Muddy Heads</p>
        <NavLink to='/category/Puzzels/Puzzel43'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    
    <div class="card 2">
    <div class="card_image">
      <img src={gb} />
      </div>
    <div class="card_title title-black">
      <p style={{fontSize:'.7em',color:'green'}}>Girl or Boy</p>
      <NavLink to='/category/Puzzels/Puzzel44'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
    </div>
   
    </div>
          <div class="cards-list"data-aos="fade-up" data-aos-delay="100">
    
  <div class="card 3">
    <div class="card_image"> <img src={stc} /> </div>
    <div class="card_title title-white">
      <p style={{fontSize:'.7em',color:'green'}}>Find the culprit</p>
      <NavLink to='/category/Puzzels/Puzzel45'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
   
    </div>
        </div>
    )
}

export default Puzz1
